export const maskEmail = (email: string): string => {
	if (!email) return "";
	const atIndex = email.indexOf("@");
	if (atIndex < 0) return email;

	const local = email.slice(0, atIndex);
	const domain = email.slice(atIndex);

	if (local.length <= 3) {
		return `${local[0] ?? ""}***${domain}`;
	}

	return `${local.slice(0, 2)}***${local.slice(-1)}${domain}`;
};


export const maskPhoneNumber = (phone: string, dialCode?: string): string => {
	if (!phone) return "";

	const local = dialCode && phone.startsWith(dialCode) ? phone.slice(dialCode.length) : phone;

	if (local.length <= 6) return local;

	const stars = "*".repeat(local.length - 6);
	return `${local.slice(0, 4)}${stars}${local.slice(-2)}`;
};